import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  FacebookIcon,
  WhatsappIcon,
  TwitterIcon,
} from "react-share";
import { Modal } from "react-bootstrap";
import { useState } from "react";
import Copy from '../assets/images/copy.svg'


const ShareModal = ({ show, onClose, property }) => {
  const url =
    typeof window !== "undefined" ? window.location.href : "";

  const title = property?.name || "Check out this property";
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("Failed to copy", err);
    }
  };

  return (
    <Modal show={show} onHide={onClose} className="contact-agent-modal"  backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Share this property</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="d-flex justify-content-center align-items-center gap-3">
          {/* Copy link */}
          <button
            onClick={copyToClipboard}
            className="border-0 bg-white"
            title="Copy link"
          >
           <img src={Copy} width={56} alt="Copy Link" />
          </button>

          {/* WhatsApp */}
          <WhatsappShareButton url={url} title={title}>
            <WhatsappIcon size={48} round />
          </WhatsappShareButton>

          {/* Facebook */}
          <FacebookShareButton url={url}>
            <FacebookIcon size={48} round />
          </FacebookShareButton>

          {/* Twitter */}
          <TwitterShareButton url={url} title={title}>
            <TwitterIcon size={48} round />
          </TwitterShareButton>
        </div>

        {copied && (
          <p className="text-center text-success mt-2 mb-0">
            Link copied!
          </p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ShareModal;
